import { render, staticRenderFns } from "./AutomatedMarketing.vue?vue&type=template&id=501f92b8&scoped=true&"
import script from "./AutomatedMarketing.vue?vue&type=script&lang=js&"
export * from "./AutomatedMarketing.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedMarketing.vue?vue&type=style&index=0&id=501f92b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501f92b8",
  null
  
)

export default component.exports